var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"float-left"}),( _vm.$route.fullPath == '/term&conditions')?_c('router-link',{staticClass:"btn mt-4 float-right new_term",attrs:{"to":"/term&conditions/new-terms"}},[_vm._v("New Terms")]):_vm._e(),_c('br'),_c('br'),_c('br'),_c('br'),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }